import { render } from "./BotaoAcoes.vue?vue&type=template&id=5f448fa6&ts=true"
import script from "./BotaoAcoes.vue?vue&type=script&lang=ts"
export * from "./BotaoAcoes.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__